import CareerCoachingPaymentView from './CareerCoachingPaymentView'
export default CareerCoachingPaymentView
